import React from 'react'
import injectStyles from 'react-jss'
import classnames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Button } from '@material-ui/core'

import { authorization } from '../../../../../Module/Auth/Auth'

import styles from '../styles'
import Eye from '../../../../../Assets/Images/icons/eye'
import TrashCanFilled from '../../../../../Assets/Images/icons/trashCanFilled'

const GrayCircularProgress = withStyles({
  root: {
    color: 'hsl(214, 17%, 57%)',
  },
})(CircularProgress)

const OnboardingQuizView = ({
  onDelete,
  isDeleting,
  pitchUrl,
  questionsLength,
  duplicateQuizToAllCities,
  uploading,
  fileUploader,
  children,
  selectedQuizType,
  setQuizType,
  quizOptions,
  allVoPartHasQuestions,
  classes,
}) => {
  return (
    <section className={classes.wrapper}>
      <div className={classes.quizTitleSection}>
        <div className={classes.title}>Quiz</div>
        <div className={classes.typeSelectorContainer}>
          {quizOptions.map(item => (
            <div
              className={
                selectedQuizType == item.value
                  ? classes.activeType
                  : classes.type
              }
              onClick={() => setQuizType(item.value)}
            >
              {item.label}
            </div>
          ))}
        </div>
        {selectedQuizType === 'onboarding' &&
          authorization.isAdmin() &&
          pitchUrl &&
          questionsLength > 0 && (
            <div className={classes.copyQuizButtonContainer}>
              <Button
                variant="outlined"
                className="copy-quiz"
                onClick={() => {
                  duplicateQuizToAllCities()
                }}
              >
                Copy quiz and docs to other cities
              </Button>
            </div>
          )}
        {selectedQuizType === 'videoOnboarding' &&
          authorization.isAdmin() &&
          allVoPartHasQuestions && (
            <div className={classes.copyQuizButtonContainer}>
              <Button
                variant="outlined"
                className="copy-quiz"
                onClick={() => {
                  duplicateQuizToAllCities()
                }}
              >
                Copy quiz to other cities
              </Button>
            </div>
          )}
      </div>
      {selectedQuizType === 'onboarding' && (
        <section className={classes.whiteBlock}>
          <div className={classes.textWrapper}>
            <span className={classes.largeText}>Onboarding documents</span>
          </div>
          <div
            className={classnames(classes.contentWrapper, {
              [classes.contentWrapperWithPitch]: !!pitchUrl,
            })}
          >
            <div className={'OnboardingQuizView-existingPitchContainer'}>
              <a
                className={classnames(
                  classes.pitchUrlContainer,
                  classes.hoverOpacity,
                )}
                href={pitchUrl}
                target="_blank"
                rel="noreferrer"
              >
                <Eye width={20} height={20} />
                <span className={classes.buttonDesc}>See Pitch</span>
              </a>
              <div
                className={classnames(
                  classes.pitchUrlContainer,
                  classes.hoverOpacity,
                  { [classes.inactive]: isDeleting },
                )}
                href={pitchUrl}
                target="_blank"
                onClick={onDelete}
              >
                {isDeleting ? (
                  <GrayCircularProgress size={25} />
                ) : (
                  <TrashCanFilled />
                )}
                <span className={classes.buttonDesc}>
                  {isDeleting ? 'Deleting...' : 'Delete Pitch'}
                </span>
              </div>
            </div>
            <div
              className={classnames(
                'OnboardingQuizView-fileUploaderContainer',
                classes.hoverOpacity,
              )}
            >
              {fileUploader}
            </div>
          </div>
        </section>
      )}
      <section className={classes.childBlock}>{children}</section>
    </section>
  )
}

export default injectStyles(styles)(OnboardingQuizView)
